export const LOAD_FULL_STOCK_DOCK =  'LOAD_FULL_STOCK_DOCK';
export const ADD_ORDER_TO_XD_DOCK = 'LOAD_XD_ORDER_TO_DOCK';

export const LOADING_MODAL_CRATE_UPDATE = 'LOADING_MODAL_CRATE_UPDATE';
